(function () {
  'use strict';

  angular.module('ringbaPortal').controller('JoinController', JoinController);

  function JoinController(
    $state,
    $stateParams,
    authService,
    utils
  ) {

    const vm = this;

    vm.passwordForm = {};
    vm.savePassword = savePassword;
    vm.setPassword = setPassword;
    vm.pageTitle = 'Set Password';
    vm.message = 'Welcome, please set your password';

    function savePassword() {
      if (vm.password === vm.confirmPassword) {
        const data = {
          password: vm.password,
          confirmPassword: vm.confirmPassword,
          token: $stateParams.t,
          id: $stateParams.u
        };

        return authService.setPassword(data)
          .then(function () {
            $state.go('login');
          }).catch(utils.errorHandler);
      }
    }

    function setPassword(data) {
      vm.password = data.password;
      vm.confirmPassword = data.confirmPassword;
    }
  }
})();
